<template lang="pug">
  #app
    loading
    menuVertical
    .container.content
      router-view
    rodape
</template>

<script>
import sidebar from '@/components/Sidebar.vue';
import menuVertical from '@/components/Navbar.vue';
import rodape from '@/components/Footer.vue';
import loading from '@/components/Loading.vue';
import events from './events.js';
import _ from 'lodash';
export default {
  name: 'App',
  components: {
    sidebar,
    menuVertical,
    rodape,
    loading
  },
  computed: {
    user () {
      return this.$store.getters.user;
    }
  },
  watch: {
    $route (route) {
      if (route.meta.public && this.user) {
        this.$router.push({ path: '/pedidos' });
      } else if (!this.user) {
        this.$router.push({ path: '/login' });
      }
    }
  },
  created () {
    const vm = this;
    _.forEach(events, function (evento) {
      vm.$on(evento.name, evento.callback);
    });
    window.getApp = vm;
  },
};
</script>

<style lang="scss">
.tdStyle{
  font-size: 13px !important;
}
body{
  margin: 0;
}
#app {
  .container{
    margin-bottom: 120px;
  }
}
.container.content {
  min-height: 70vh!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue